// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root___A9Sm","inner":"Footer_inner__27qDv"};